import React, { useEffect, useCallback, useState } from 'react';
import SearchCondition from './components/search_condition/index';
import ActivityResult from './components/activity_result/index';
import { Button } from '@material-ui/core';
// import ActivityExport from './components/activity_export/index';
import { useLocation, history } from 'umi';
import { useDispatch } from 'dva';
import qs from 'qs';
// import webStorage from '@/utils/storageManager';
import dayjs from 'dayjs';
import ActivityViewStyled from './ActivityViewStyled.jsx';
import CloseIcon from '@material-ui/icons/Close';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [modification, setModification] = useState({});
  const { query, pathname } = location;
  const {
    memberId,
    mobile,
    type,
    // approvalState,
    pageNum = '1',
    pageSize = '10',
    time,
  } = query;

  // const DICTOBJ = webStorage.get('DICTOBJ');
  // const { MANUAL_OPERATION_APPROVE_STATE } = DICTOBJ || [];
  // const { MANUAL_OPERATION_TYPE } = DICTOBJ || [];

  const timestamp = dayjs().format('YYYY-MM-DD HH-mm-ss');

  // 查询事件处理
  const handleSearch = (newParam) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: '1',
        time: timestamp,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: '1',
      })}`,
    );
  };

  // 获取列表
  const fetchData = useCallback(() => {
    dispatch({
      type: 'adjustmentData/getViewList',
      payload: {
        values: {
          memberId: memberId || null,
          mobile: mobile || null,
          type: type || null,
          // approvalState: approvalState || null,
          pageNum,
          pageSize,
          time,
        },
      },
    });
  }, [
    dispatch,
    pageNum,
    pageSize,
    mobile,
    memberId,
    type,
    // approvalState,
    time,
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {/* <ActivityExport>
    </ActivityExport> */}
      <ActivityViewStyled>
        <div className="result-wrap">
          <SearchCondition
            query={query}
            handleSearch={(par) => handleSearch(par)}
            // setModification={setModification}
            restClick={handleRestClick}
          ></SearchCondition>
          <ActivityResult
            modification={modification}
            setModification={setModification}
            setPageData={handlePageChange}
            pagination={{
              pageNum,
              pageSize,
            }}
          ></ActivityResult>
        </div>
        <div className="btn-wrap">
          <Button
            variant="contained"
            color="secondary"
            onClick={() => history.goBack()}
            startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
          >
            退出
          </Button>
        </div>
      </ActivityViewStyled>
    </>
  );
};
